import useQuery from '@/compositions/useQuery';
import useMutation from '@/compositions/useMutation';

export function executeQuery(query, variables, options) {
  return new Promise((resolve, reject) => {
    const { onResult, onError } = useQuery(query, variables, options);

    onResult((data) => {
      resolve(data);
    });

    onError((error) => {
      reject(error);
    });
  });
}

export function executeMutation(mutation, variables, options, errorPolicy = 'none') {
  return new Promise((resolve, reject) => {
    const { mutate, onDone, onError } = useMutation(mutation);
    mutate(variables, options);

    onDone(({ data }) => {
      resolve({ success: true, ...data });
    });

    if (errorPolicy === 'validation') {
      onError((error) => {
        const realErrors = error.networkError?.result?.errors;
        const errors = {};
        if (
          realErrors?.every((e) => {
            if (e.code === 'ValidationError') {
              if (!errors[e.field]) {
                errors[e.field] = [];
              }
              errors[e.field].push(e.message);
              return true;
            }
          })
        ) {
          resolve({
            success: false,
            errors,
          });
        }
        reject(error);
      });
    } else {
      onError((error) => {
        reject(error);
      });
    }
  });
}
